var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 135.5 28.8",
    style: {
      enableBackground: "new 0 0 177.6 28.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st0-footer {\n\t\t\tfill: #303030;\n\t\t}\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-footer"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-footer"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0-footer",
    d: "M18.6,13L11.2,1.7c-0.2-0.3-0.5-0.4-0.8-0.4c-0.3,0-0.7,0.2-0.8,0.4L2,13c-1,1.6-1.6,3.4-1.6,5.5 c0,3.9,2.2,7.3,5.5,8.9l0.2-5l0,0H5v0.7c0.2,0.1,0.3,0.3,0.3,0.5c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 c0-0.2,0.1-0.4,0.3-0.5v-0.7h0c-0.2,0-0.3-0.1-0.3-0.3v-1c0-0.2,0.1-0.3,0.3-0.3h0v-0.7c-0.2-0.1-0.3-0.3-0.3-0.5 c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.2-0.1,0.4-0.3,0.5v0.7h1.4v-4.5c0-1.3,0-2.3,0.8-3.6c1.7-2.9,5.9-2.6,7.4,1.5 l0.8,2.2c0.1,0.2-0.1,0.4-0.3,0.4h-1.6c-0.2,0-0.3-0.1-0.3-0.3v-1.4L13,14.7c-0.5-1.4-1.5-2.2-2.5-2.3c-0.8-0.1-1.5,0.3-2,1.1 C8,14.4,8,15.1,8,16.3l0,4.5h0.3c0.2,0,0.3,0.1,0.3,0.3l0.2,7.2c0.5,0.1,1,0.1,1.6,0.1c5.5,0,9.9-4.4,9.9-9.9 C20.3,16.4,19.7,14.6,18.6,13z M14.3,20.2c-0.5,0-0.9-0.4-0.9-0.9c0-0.2,0.1-0.3,0.1-0.5l0.7-1c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0 l0.7,1c0.1,0.1,0.1,0.3,0.1,0.5C15.2,19.8,14.8,20.2,14.3,20.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0-footer",
    d: "M29.4,19.9h3.3v-8.3c0-0.5,0-1,0-1h0c0,0-0.2,0.4-0.7,0.8l-1.2,1.1l-1.6-1.7l3.8-3.6h2.4v12.7h3.3v2.3h-9.2 V19.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0-footer",
    d: "M40.5,20.9c0-5.4,7-6.3,7-9.3c0-1.3-1-2.1-2.3-2.1c-1.8,0-2.7,1.8-2.7,1.8l-2-1.4c0,0,1.4-3,5-3 c2.6,0,4.9,1.6,4.9,4.4c0,4.8-6.7,5.6-6.8,8.5h7v2.3h-10C40.6,21.8,40.5,21.3,40.5,20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0-footer",
    d: "M52.5,14.7c0-4.3,1.3-7.7,5.4-7.7c4.1,0,5.5,3.4,5.5,7.7c0,4.3-1.4,7.8-5.5,7.8C53.8,22.5,52.5,19,52.5,14.7 z M60.6,14.7c0-2.9-0.6-5.2-2.6-5.2c-2.1,0-2.6,2.3-2.6,5.2c0,3,0.6,5.3,2.6,5.3C60,20,60.6,17.7,60.6,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0-footer",
    d: "M74.4,9.6c0,0-0.2,1.3-0.5,2.2L71,22.3h-1.8L65.4,7.4H67l2.9,11.5c0.2,0.8,0.3,1.6,0.3,1.6h0 c0,0,0.1-0.8,0.3-1.6l3.1-11.5h1.4l3.1,11.5c0.2,0.8,0.3,1.6,0.3,1.6h0c0,0,0.1-0.8,0.3-1.6l3-11.5h1.5l-4,14.9h-1.8l-2.8-10.5 C74.6,10.8,74.4,9.6,74.4,9.6L74.4,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0-footer",
    d: "M90.2,15.7h0.6v-0.3c0-2.1-1.1-2.7-2.6-2.7c-1.8,0-3,1-3,1l-0.7-1.1c0,0,1.4-1.2,3.8-1.2c2.6,0,4,1.4,4,4.1 v6.8h-1.4v-1.2c0-0.5,0-0.9,0-0.9h0c0,0-0.9,2.3-3.6,2.3c-1.8,0-3.6-1-3.6-3.2C83.6,15.8,88.3,15.7,90.2,15.7z M87.5,21.3 c2,0,3.3-2.1,3.3-4v-0.5h-0.6c-1.7,0-5,0.1-5,2.4C85.1,20.3,85.9,21.3,87.5,21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0-footer",
    d: "M106.6,11.4c2.9,0,4.4,2.3,4.4,4.9c0,0.3,0,0.7,0,0.7h-8.2c0.1,2.7,1.9,4.2,4.1,4.2c1.9,0,3.2-1.3,3.2-1.3 l0.7,1.1c0,0-1.5,1.5-3.9,1.5c-3.2,0-5.6-2.3-5.6-5.6C101.4,13.5,103.8,11.4,106.6,11.4z M109.6,15.8c-0.1-2.2-1.4-3.3-3-3.3 c-1.8,0-3.3,1.1-3.7,3.3H109.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0-footer",
    d: "M113.8,11.6h1.4v1.9c0,0.5,0,0.8,0,0.8h0c0.5-1.6,1.7-2.8,3.4-2.8c0.3,0,0.6,0.1,0.6,0.1V13c0,0-0.3,0-0.5,0 c-1.5,0-2.6,1.2-3.1,2.7c-0.2,0.7-0.3,1.4-0.3,2.1v4.5h-1.4V11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0-footer",
    d: "M95.6,12.8h-1.4v-1.2h1.4V7.4H97v4.2h2.7v1.2H97v5.4c0,2.5,1.6,2.8,2.4,2.8c0.3,0,0.5,0,0.5,0v1.3 c0,0-0.2,0-0.6,0c-1.2,0-3.7-0.4-3.7-4V12.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0-footer",
    d: "M124.9,8.2h-2.1V7.4h5.2v0.8h-2.1v5.5h-0.9V8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0-footer",
    d: "M129.1,7.4h0.9l1.4,3.4c0.1,0.3,0.3,0.8,0.3,0.8h0c0,0,0.2-0.5,0.3-0.8l1.4-3.4h0.9l0.5,6.2h-0.9l-0.3-3.9 c0-0.4,0-0.9,0-0.9h0c0,0-0.2,0.6-0.3,0.9l-1.2,2.8h-0.8l-1.2-2.8c-0.1-0.3-0.3-0.9-0.3-0.9h0c0,0,0,0.6,0,0.9l-0.3,3.9h-0.9 L129.1,7.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/footer.436239a98333a8ab6e9661f94b51afc9.svg";
export { ForwardRef as ReactComponent };